import axios from './request'

const URL = {
  contract: {
    list: '/CONTRACT-MANAGER-SERVICE/contract/queryUserContractPage.magpie', // 客户合同列表查询
    applyAuth: '/MATCH-FACADE-SERVER/contract/applyAuth.magpie', // 申请授权验证码
    confirmAuth: '/MATCH-FACADE-SERVER/contract/confirmAuth.magpie', // 验证授权验证码
  },
}

class Contract {
  // 客户合同列表查询
  contractList (params) {
    const url = URL.contract.list
    return axios.post(url, params)
  }
  // 获取验证码
  applyAuth (params) {
    const url = URL.contract.applyAuth
    return axios.post(url, params)
  }
  // 验证并签署
  confirmAuth (params) {
    const url = URL.contract.confirmAuth
    return axios.post(url, params)
  }
}

export default new Contract()
